import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index'
import Pay from '@/views/pay'
import bounceBack from '@/views/bounce_back'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Index
    },{
      path: '/pay',
      component: Pay
    },{
      path: '/bounce_back',
      component: bounceBack
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js